export const environment = {
  socketPath: '/socket.io',
  serverHost: 'https://lacolonial.com.do/',
  mapsKey: 'AIzaSyDjZu-yR3TJwMWpwXEPpis6s0xBMCUYs6I',
  msalConfig: {
    auth: {
      clientId: '74cf4e5f-b751-454a-8e5a-7f00faae470c',
    },
  },
  apiConfig: {
    scopes: [
      'offline_access',
      'openid',
      'https://labloginlacolonial.onmicrosoft.com/c45995f1-18f7-4f48-9e51-f0424bda6d50/MovilAPI.Read',
      'https://labloginlacolonial.onmicrosoft.com/c45995f1-18f7-4f48-9e51-f0424bda6d50/MovilAPI.ReadWrite',
    ],
    uri: '',
  },
  b2cPolicies: {
    names: {
      signUpSignIn: 'B2C_1_SignIn',
      signUp: 'B2C_1_SignupClient',
      resetPassword: 'B2C_1_password_reset',
      editProfile: 'B2C_1_profile_edit',
    },
    authorities: {
      signUpSignIn: {
        authority:
          'https://labloginlacolonial.b2clogin.com/labloginlacolonial.onmicrosoft.com/B2C_1_SignIn',
      },
      signUp: {
        authority: {
          client:
            'https://labloginlacolonial.b2clogin.com/labloginlacolonial.onmicrosoft.com/B2C_1_SignupClient',
          producer:
            'https://labloginlacolonial.b2clogin.com/labloginlacolonial.onmicrosoft.com/B2C_1_SignupProducer',
        },
      },
      resetPassword: {
        authority:
          'https://labloginlacolonial.b2clogin.com/labloginlacolonial.onmicrosoft.com/B2C_1_password_reset',
      },
      editProfile: {
        authority:
          'https://labloginlacolonial.b2clogin.com/labloginlacolonial.onmicrosoft.com/B2C_1_profile_edit',
      },
    },
    authorityDomain: 'labloginlacolonial.b2clogin.com',
  },
  paymentRoute: 'https://DevEpaymentProxyAPI.lacolonial.com.do/api/',
  claimsRoute: 'https://DevDigitalClaimAPI.lacolonial.com.do/api/',
  apiRoute: 'https://devlacolonialservicesmobile.lacolonial.com.do/api/',
  identityRoute: 'https://login.lacolonial.com.do/',
  cmsRoute: 'https://lacolonial.com.do/wp-json/wp/v2/',
};
